<app-sidenav></app-sidenav>
<app-header></app-header>
<div class="main-content">
  <router-outlet />

  <app-business-status-block-overlay [status]="businessStatus"></app-business-status-block-overlay>
  <app-subscription-payment [status]="businessStatus"></app-subscription-payment>
  <app-beta-registration-block-overlay></app-beta-registration-block-overlay>
</div>
